/** API Core */
export const coreCategoriesRoute = `virtual/categories`;
